// Thin Patient Brief — the REPLACE of the mockup chart. Demographics (admin only) + thin
// visit_summaries + the Healthie hand-off. Only admin demographics + a thin recap render here;
// the full record (conditions, medications, allergies, labs) stays in Healthie (D5/D10). Shared
// contract with doctor mobile (WF15).
import type { PatientBrief as Brief } from "@forcebase-ai/schema/doctor";
import { age, formatDateTime } from "../lib/format";
import { EmrHandoff } from "./EmrHandoff";

export function PatientBrief({ brief }: { brief: Brief }) {
  const p = brief.patient;
  const initials = `${p.first_name.charAt(0)}${p.last_name.charAt(0)}`.toUpperCase();

  return (
    <div>
      <div className="dp-detail__head">
        <div className="dp-detail__avatar">{initials}</div>
        <div>
          <div className="dp-detail__name">
            {p.first_name} {p.last_name}
          </div>
          <div className="dp-detail__meta">
            {age(p.dob)} years old{p.dob ? ` · DOB ${p.dob}` : ""}
          </div>
        </div>
        <div className="dp-detail__actions">
          <a className="dp-btn dp-btn--ghost" href={`/messages?patient=${p.id}`}>
            Message
          </a>
        </div>
      </div>

      <div className="dp-info-grid">
        <div>
          <div className="dp-info__k">Phone</div>
          <div className="dp-info__v">{p.phone ?? "—"}</div>
        </div>
        <div>
          <div className="dp-info__k">Email</div>
          <div className="dp-info__v">{p.email ?? "—"}</div>
        </div>
        <div>
          <div className="dp-info__k">Insurance</div>
          <div className="dp-info__v">{p.insurance_carrier ?? "—"}</div>
        </div>
        <div>
          <div className="dp-info__k">Membership</div>
          <div className="dp-info__v cap">{p.tier}</div>
        </div>
      </div>

      <div className="dp-sech">Recent visit notes</div>
      {brief.visit_summaries.length ? (
        <div className="dp-notes">
          {brief.visit_summaries.map((s) => (
            <div className="dp-note" key={s.id}>
              <div className="dp-note__date">{formatDateTime(s.last_visit_at)}</div>
              <p className="dp-note__text">{s.summary_text}</p>
            </div>
          ))}
        </div>
      ) : (
        <p className="muted">No visit notes yet.</p>
      )}

      <div style={{ marginTop: 18 }}>
        <EmrHandoff patientRef={p.healthie_patient_id} />
      </div>
    </div>
  );
}
